module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_04-efc11c6891dc8bf2a0d58607d3ddbb93.webp";